<template>
    <div>
        <video-image-modal />
        <label :for="id" class="label text-left"><strong>{{labelText}}</strong></label>
        <div class="input-group mb-3">
            <input :id="id" type="file" ref="fileUploader" class="form-control" @change="changed" />
            <input style="opacity: 0; position: absolute; z-index: -1;" type="file" :name="id" v-if="required" :required="files.length === 0"/>
            <div class="input-group-append" v-if="required || files.length">
                <span class="input-group-text" v-bind:class="files.length ? 'text-success' : ''" v-b-tooltip.hover :title="tooltipTitle">
                    <font-awesome-icon style="margin: auto" :icon="files.length ? 'check' : 'exclamation'"/>
                </span>
            </div>
        </div>
        <div class="image-preview" v-if="inputType === 'image'">
            <div class="image" v-for="(img, i) in files" :key="i" v-on:click.stop="$modal.show('video-image-modal', {imageURI: img.uri})">
                <div class="img" :style="`background-image: url('${img.uri}')`"></div>
                <font-awesome-icon style="color: #e45649; position: absolute; top: -0.7em; right: -0.7em" :icon="fileDeleting ? 'circle-notch':'times-circle'" :spin="fileDeleting" v-b-tooltip.hover title="Click to delete image" @click.stop="deleteFile(i)"/>
            </div>
        </div>
        <div class="video-preview" v-if="inputType === 'video'">
            <div class="video" v-for="(vid, i) in files" :key="i" v-on:click.stop="$modal.show('video-image-modal', {videoURI: vid.uri})">
                <video :src="vid.uri"></video>
                <img class="video-play-icon" src="../assets/upload.png" />
                <font-awesome-icon style="color: #e45649; position: absolute; top: -0.7em; right: -0.7em" :icon="fileDeleting ? 'circle-notch':'times-circle'" :spin="fileDeleting" v-b-tooltip.hover title="Click to delete image" @click.stop="deleteFile(i)"/>
            </div>
        </div>
    </div>
</template>

<script>

import VideoImageModal from "@/components/VideoImageModal";

export default {
    name: "FormFilesUploader",
    components: {
        VideoImageModal
    },
    props: {
        labelText: String,
        files: {type: Array, default: () => {return [];}},
        inputType: {
            validator (val) {
                return ['image', 'video'].indexOf(val) !== -1
            }
        },
        required: {type: Boolean, default: false},
        tooltipTitle: String,
        fileChanged: Function,
        deleteFile: Function,
        fileDeleting: Boolean
    },
    data() {
        return {
            id: Date.now() + '-' + Math.random().toString(36).substring(7)
        }
    },
    methods: {
        changed() {
            this.fileChanged(this.$refs.fileUploader.files);
            this.$refs.fileUploader.value = "";
        }
    }
};
</script>

<style scoped lang="scss">
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}
.input-group-text {
    width: 45px;
}
.image-preview, .video-preview {
    text-align: left;

    .image, .video {
        position: relative;
        height: 100px;
        width: 150px;
        margin: 5px;
        display: inline-block;
        cursor: pointer;

        .video-play-icon {
            position: absolute;
            left: 39px;
            top: 14px;
        }

        .img, video {
            height: 100px;
            width: 150px;
            border-radius: 1em;
            border: 1px solid darkgray;
        }
        .img {
            padding: 2px;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: rgba(0, 0, 0, 1);
            background-position: center center;
        }
    }
}
</style>

